import React, { useState, useRef, useEffect } from "react";
import { Sparkles, Send, X } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";

export default function Assistant() {
  const { t } = useApp();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([{ role: "ai", text: "నమస్తే 🙏 నేను పూజారి సహాయకుడిని. దేవాలయ ఖాళీలు, అర్చక నమోదు, గోత్రం, క్రెడిట్స్ గురించి ఏదైనా అడగండి." }]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [sid, setSid] = useState("");
  const boxRef = useRef(null);

  useEffect(() => { if (boxRef.current) boxRef.current.scrollTop = boxRef.current.scrollHeight; }, [msgs, open]);

  const send = async () => {
    if (!input.trim() || busy) return;
    const q = input.trim();
    setMsgs((m) => [...m, { role: "user", text: q }]); setInput(""); setBusy(true);
    try {
      const { data } = await api.post("/ai/assistant", { message: q, session_id: sid });
      setSid(data.session_id);
      setMsgs((m) => [...m, { role: "ai", text: data.reply.replace(/\*\*(.+?)\*\*/g, "$1").replace(/^\s*[*-]\s+/gm, "• ").replace(/^#+\s*/gm, "") }]);
    } catch (e) {
      const d = e?.response?.data?.detail;
      setMsgs((m) => [...m, { role: "ai", text: typeof d === "string" && e.response.status !== 500 ? d : "క్షమించండి, సహాయకుడు ప్రస్తుతం అందుబాటులో లేడు." }]);
    } finally { setBusy(false); }
  };

  return (
    <>
      <button data-testid="assistant-toggle" onClick={() => setOpen(true)}
        className="fixed bottom-24 right-5 z-40 w-14 h-14 rounded-full bg-maroon text-marigold temple-shadow flex items-center justify-center hover:scale-105 transition-transform">
        <Sparkles className="w-6 h-6" />
      </button>
      {open && (
        <div className="fixed bottom-5 right-5 z-50 w-[92vw] max-w-sm h-[70vh] max-h-[560px] bg-surface rounded-2xl temple-shadow gold-border flex flex-col overflow-hidden animate-fade-up" data-testid="assistant-panel">
          <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-maroon to-saffron text-white">
            <div className="flex items-center gap-2 font-telugu font-semibold"><Sparkles className="w-5 h-5" /> {t("ai_assistant")}</div>
            <button data-testid="assistant-close" onClick={() => setOpen(false)}><X className="w-5 h-5" /></button>
          </div>
          <div ref={boxRef} className="flex-1 overflow-y-auto p-3 space-y-3 parchment-texture">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[85%] px-3 py-2 rounded-2xl text-sm font-telugu whitespace-pre-wrap ${m.role === "user" ? "bg-saffron text-white rounded-br-sm" : "bg-marigold/15 text-maroon rounded-bl-sm border border-goldline/30"}`}>
                  {m.text}
                </div>
              </div>
            ))}
            {busy && <div className="text-xs text-muted-foreground font-telugu px-2">సహాయకుడు ఆలోచిస్తున్నాడు...</div>}
          </div>
          {!user ? (
            <div className="p-3 border-t border-goldline/30 text-center">
              <Link data-testid="assistant-login-link" to="/auth?mode=login" onClick={() => setOpen(false)} className="btn-sacred inline-block px-5 py-2 rounded-full text-sm font-telugu">సహాయకుడిని అడగడానికి లాగిన్ అవ్వండి</Link>
            </div>
          ) : (
          <div className="p-3 border-t border-goldline/30 flex gap-2">
            <input data-testid="assistant-input" maxLength={1000} value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder={t("ask_ai")} className="flex-1 px-3 py-2 rounded-full border border-goldline/40 bg-white text-sm font-telugu outline-none focus:ring-2 focus:ring-saffron/40" />
            <button data-testid="assistant-send" onClick={send} disabled={busy} className="btn-sacred border-0 rounded-full w-10 h-10 flex items-center justify-center">
              <Send className="w-4 h-4" />
            </button>
          </div>
          )}
        </div>
      )}
    </>
  );
}
